import { render, staticRenderFns } from "./ListAsetDihibahkanPage.vue?vue&type=template&id=1b5f37e8"
import script from "./ListAsetDihibahkanPage.vue?vue&type=script&lang=js"
export * from "./ListAsetDihibahkanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports